module.exports = __webpack_public_path__ + "img/hr-heat-pipe-straight-vertical-4.2a9ec2e7.png";